import { actionTextColor } from "../../utils/themeContrast";
import React from "react";
import { CarouselProvider, Slider, Slide, DotGroup } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import styled from "@emotion/styled";
import { IoIosAdd, IoIosRemove } from "react-icons/io";
import ItemSize5 from "./ItemSize5";
import { ThemeContext, UserContext, LanguageContext } from "../../contexts/Context";

const MenuCarousel = ({
  isSetMeal,
  array, //each Option Grou
  setArrayState,
  isMultiple,
  produceNewState,
  produceMultiState,
  hasRecommended,
  visibleSlide,
  adjustQuantity,
  lanIndex,
  isLanReverse,
  currencySymbol,
  menuIndex,
  cp,
  optionType,
  recommendationClick,
  recommendationQtyAdjust
}) => {
  const themeContext = React.useContext(ThemeContext);
  const languageContext = React.useContext(LanguageContext);
  const { tax, displayNetAmount, hidePrice } = React.useContext(UserContext);
  const getTitle = (item) => (
    (lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse)
      ? item.title
      : (item.title2 || item.title)
  );
  const getDescription = (item) => (
    (lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse)
      ? item.description
      : (item.description2 || item.description)
  );
  const getPrice = (item) => (
    displayNetAmount
      ? item.price * (1 + (tax.taxMode == 0 ? tax.tax : (item.tax || 0)))
      : item.price
  );
  //when user click item
  const handleOnClick = (array, codeId, isMultiple) => {
    if (hasRecommended) {
      recommendationClick(array, codeId);
    } else if (!hasRecommended && isMultiple) {
      setArrayState(produceMultiState(array, codeId));
    } else {
      setArrayState(produceNewState(array, codeId, isMultiple, hasRecommended, menuIndex));
    }
  };
  const handleQtyClick = (array, qty, index) => {
    if (hasRecommended) {
      recommendationQtyAdjust(array, qty, index);
    } else {
      setArrayState(adjustQuantity(array, qty, index));
    }
  }
  return (
    <React.Fragment>
      {(optionType == 5 || optionType == 6) && array.map((item, index) => (
        <div
          index={index}
          key={item.codeId ? item.codeId : "" + index + item.title}
        >
          <ItemSize5
            isSetMeal={isSetMeal}
            active={item.active}
            item={item}
            lanIndex={lanIndex}
            isLanReverse={isLanReverse}
            hasRecommended={hasRecommended}
            currencySymbol={currencySymbol}
            optionType={optionType}
            handleOnClick={() => {
              handleOnClick(array, item.codeId, isMultiple);
            }}
            adjustQuantity={(qty) => {
              handleQtyClick(array, qty, index);
            }}
            cp={0}
          />
        </div>
      ))}
      {optionType == 3 && hasRecommended &&
        <RecommendationGrid>
          {array.map((item, index) => {
            const quantity = item.qty || 0;
            const isSelected = item.active || quantity > 0;
            return (
              <RecommendationCard
                key={item.codeId ? item.codeId : "" + index + item.title}
                themeContext={themeContext}
                selected={isSelected}
                role="button"
                tabIndex={item.isSoldOut ? -1 : 0}
                aria-disabled={item.isSoldOut}
                onClick={() => {
                  if (!item.isSoldOut) handleOnClick(array, item.codeId, isMultiple);
                }}
                onKeyDown={(event) => {
                  if (!item.isSoldOut && (event.key === "Enter" || event.key === " ")) {
                    event.preventDefault();
                    handleOnClick(array, item.codeId, isMultiple);
                  }
                }}
              >
                <RecommendationImage image={item.image}>
                  {!hidePrice && item.price > 0 &&
                    <RecommendationPrice themeContext={themeContext}>
                      {`${isSetMeal ? "+" : ""}${currencySymbol} ${getPrice(item).toFixed(2)}`}
                    </RecommendationPrice>
                  }
                  {isSelected && <SelectedBadge themeContext={themeContext}>&#10003;</SelectedBadge>}
                  {item.isSoldOut && <SoldOutImage src="/soldout.png" />}
                </RecommendationImage>
                <RecommendationBody>
                  <RecommendationTitle themeContext={themeContext}>{getTitle(item)}</RecommendationTitle>
                  {getDescription(item) &&
                    <RecommendationDescription themeContext={themeContext}>
                      {getDescription(item)}
                    </RecommendationDescription>
                  }
                  <RecommendationAction themeContext={themeContext}>
                    {quantity > 0 ?
                      <RecommendationQuantity>
                        <QuantityButton
                          type="button"
                          themeContext={themeContext}
                          onClick={(event) => {
                            event.stopPropagation();
                            handleQtyClick(array, Math.max(0, quantity - 1), index);
                          }}
                          aria-label="Decrease quantity"
                        >
                          <IoIosRemove size={18} />
                        </QuantityButton>
                        <QuantityValue>{quantity}</QuantityValue>
                        <QuantityButton
                          type="button"
                          themeContext={themeContext}
                          onClick={(event) => {
                            event.stopPropagation();
                            handleQtyClick(array, quantity + 1, index);
                          }}
                          aria-label="Increase quantity"
                        >
                          <IoIosAdd size={18} />
                        </QuantityButton>
                      </RecommendationQuantity>
                      :
                      <AddLabel>
                        <IoIosAdd size={18} />
                        {(languageContext[lanIndex] && languageContext[lanIndex].add) || "Add"}
                      </AddLabel>
                    }
                  </RecommendationAction>
                </RecommendationBody>
              </RecommendationCard>
            );
          })}
        </RecommendationGrid>
      }
      {optionType == 3 && !hasRecommended && <SetMealGrid>
        {array.map((item, index) => <ItemSize5
          key={item.codeId || index}
          cardLayout
          isSetMeal={isSetMeal}
          active={item.active}
          item={item}
          lanIndex={lanIndex}
          isLanReverse={isLanReverse}
          currencySymbol={currencySymbol}
          optionType={optionType}
          handleOnClick={() => handleOnClick(array, item.codeId, isMultiple)}
        />)}
      </SetMealGrid>}
      {/* </Slider> */}
      {/* <DotGroup /> */}
    </React.Fragment>
  );
};

export default MenuCarousel;

const SetMealGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 4px 16px 12px;
  box-sizing: border-box;
  width: 100%;
  @media (min-width: 1024px) { grid-template-columns: repeat(3, minmax(0, 1fr)); }
`;

const RecommendationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  width: 100%;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 18px;
  }

  @media (max-width: 360px) {
    grid-template-columns: 1fr;
  }
`;

const RecommendationCard = styled.div`
  display: flex;
  min-width: 0;
  padding: 0;
  flex-direction: column;
  overflow: hidden;
  border: 2px solid ${(props) => props.selected ? props.themeContext.primaryColor : (props.themeContext.borderColor || "#ddd")};
  border-radius: 12px;
  color: ${(props) => props.themeContext.fontPrimary};
  background: ${(props) => props.themeContext.backgroundColor};
  box-shadow: ${(props) => props.selected ? "0 7px 18px rgba(0, 0, 0, 0.16)" : "0 3px 10px rgba(0, 0, 0, 0.09)"};
  text-align: left;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 9px 22px rgba(0, 0, 0, 0.15);
  }

  &[aria-disabled="true"] {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;

const RecommendationImage = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (min-width: 768px) {
    aspect-ratio: 4 / 3;
  }
`;

const RecommendationPrice = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
  padding: 4px 7px;
  border-radius: 6px;
  color: #fff;
  background: rgba(0, 0, 0, 0.72);
  font-family: ${(props) => props.themeContext.fontFamily};
  font-size: 13px;
  font-weight: 700;
`;

const SelectedBadge = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  border-radius: 50%;
  color: ${props => actionTextColor(props.themeContext, props.themeContext.primaryColor)};
  background: ${(props) => props.themeContext.primaryColor};
  font-size: 15px;
  font-weight: 700;
`;

const SoldOutImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 82%;
  transform: translate(-50%, -50%);
`;

const RecommendationBody = styled.div`
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  min-height: 104px;
  box-sizing: border-box;
  padding: 11px 12px 10px;
  flex-direction: column;
`;

const RecommendationTitle = styled.div`
  display: -webkit-box;
  color: ${(props) => props.themeContext.fontPrimary};
  font-family: ${(props) => props.themeContext.fontFamily};
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

const RecommendationDescription = styled.div`
  display: -webkit-box;
  margin-top: 5px;
  color: ${(props) => props.themeContext.descriptionColor || "#777"};
  font-family: ${(props) => props.themeContext.fontFamily};
  font-size: 12px;
  line-height: 1.35;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

const RecommendationAction = styled.div`
  display: flex;
  min-height: 32px;
  margin-top: auto;
  padding-top: 9px;
  align-items: center;
  justify-content: flex-end;
  color: ${(props) => props.themeContext.primaryColor};
  font-family: ${(props) => props.themeContext.fontFamily};
  font-size: 13px;
  font-weight: 700;
`;

const AddLabel = styled.span`
  display: inline-flex;
  gap: 3px;
  align-items: center;
`;

const RecommendationQuantity = styled.div`
  display: grid;
  grid-template-columns: 30px 34px 30px;
  height: 30px;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
`;

const QuantityButton = styled.button`
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  border: 0;
  color: ${(props) => props.themeContext.primaryColor};
  background: transparent;
  cursor: pointer;
`;

const QuantityValue = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
  color: #555;
  font-size: 13px;
  font-weight: 700;
`;
